<template>
  <transition name="editor-snackbar">
    <div v-if="show" class="editor-snackbar" :style="toastStyle">
      {{ editorSnackbarMessage }}
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const SIDEBAR_WIDTH = 300

export default {
  name: 'EditorSnackbar',
  computed: {
    ...mapGetters('editor', ['isEditorSnackbarVisible', 'editorSnackbarMessage']),
    ...mapGetters('layoutEditor', ['isLayoutEditUIActive']),
    show() {
      return this.isEditorSnackbarVisible
    },
    toastStyle() {
      const offset = this.isLayoutEditUIActive ? SIDEBAR_WIDTH : 0
      return { left: `calc(${offset}px + (100vw - ${offset}px) / 2)` }
    },
  },
  watch: {
    show(val) {
      if (val) {
        clearTimeout(this._timer)
        this._timer = setTimeout(() => this.setEditorSnackbarVisibility(false), 3000)
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this._timer)
  },
  methods: {
    ...mapActions('editor', ['setEditorSnackbarVisibility']),
  },
}
</script>

<style scoped>
.editor-snackbar {
  position: fixed;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  pointer-events: none;
}
</style>

<style>
.editor-snackbar-enter-active,
.editor-snackbar-leave-active {
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s;
}
.editor-snackbar-enter,
.editor-snackbar-leave-to {
  transform: translate(-50%, 12px);
  opacity: 0;
}
</style>
